import Component from './component';

Component.defaultProps = {
    memoParams: [],
    localTranslations: {},
    enabledStates: {},
};
export default Component;